import { createAsyncActionTypes } from '@mews/framework';
import { prefix } from '../module';

export const MESSAGE_DRAFT_UPDATED = prefix('MESSAGE_DRAFT_UPDATED');
export const MESSAGE_ADDED = prefix('MESSAGE_ADDED');
export const MESSAGE_UPDATED = prefix('MESSAGE_UPDATED');
export const MESSAGE_REMOVED = prefix('MESSAGE_REMOVED');
export const MESSAGES_FETCHING = prefix('MESSAGES_FETCHING');
export const [MESSAGES_FETCHING_STARTED, MESSAGES_FETCHING_SUCCEEDED] = createAsyncActionTypes(MESSAGES_FETCHING);
